import { sumStringLength } from '../../helpers/sumStringLength';
import { checkDigitsAndUppercaseLettersCount, checkDigitsCount, checkInnFormat, checkMaxLength, checkNotEmpty, checkRecipientAccount, } from '../../helpers/validators';
export const getOrganizationValidationInfo = ({ requisites, required, }) => {
    const isOrgRequired = required || sumStringLength(Object.values(requisites)) > 0;
    const checkOrgRequired = (value, message) => {
        return isOrgRequired ? checkNotEmpty({ value, message, type: 'lostfocus', independent: false }) : null;
    };
    const sfrMessage = requisites.registrationNumberSfr === null || requisites.registrationNumberSfr === undefined
        ? undefined
        : 'Регномер СФР или регномер ФСС должен быть заполнен';
    const checkRegistrationNumberRequired = (value) => {
        return !requisites.registrationNumberSfr ? checkOrgRequired(value, sfrMessage) : false;
    };
    const checkRegistrationNumberSfrRequired = (value) => {
        return !requisites.registrationNumber ? checkOrgRequired(value, sfrMessage) : false;
    };
    return {
        bik: checkOrgRequired(requisites.bik) || checkDigitsCount(requisites.bik, 9),
        name: checkOrgRequired(requisites.name) || checkMaxLength({ value: requisites.name || '', length: 120 }),
        paymentAccount: checkOrgRequired(requisites.paymentAccount) || checkDigitsCount(requisites.paymentAccount, 20),
        account: checkDigitsAndUppercaseLettersCount(requisites.account, 11),
        recipientAccount: checkRecipientAccount(requisites.recipientAccount, 5, 20),
        kbk: checkDigitsAndUppercaseLettersCount(requisites.kbk, 20),
        registrationNumberSfr: checkRegistrationNumberSfrRequired(requisites.registrationNumberSfr) ||
            checkDigitsCount(requisites.registrationNumberSfr, 10),
        registrationNumber: checkRegistrationNumberRequired(requisites.registrationNumber) ||
            checkDigitsCount(requisites.registrationNumber, 10),
        inn: checkOrgRequired(requisites.inn) ||
            checkDigitsCount(requisites.inn, 10) ||
            checkInnFormat({ value: requisites.inn || '' }),
        kpp: checkOrgRequired(requisites.kpp) || checkDigitsCount(requisites.kpp, 9),
        bankCombo: checkOrgRequired(requisites.name) || checkOrgRequired(requisites.bik),
    };
};
